import { styled } from '../../config'
import { Box } from '../Box'

/**
 * Responsive Container for main content of a page.
 * @example
 * <ResponsiveContainer>
 *  ...
 * </ResponsiveContainer>
 */
export const ResponsiveContainer = styled(Box, {
  maxWidth: '1280px',
  margin: 'auto',
  paddingLeft: '16px',
  paddingRight: '16px',
  boxSizing: 'border-box',
  '@tablet': {
    paddingLeft: '48px',
    paddingRight: '48px'
  }
})
